var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaBigGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.946,
    height: 27.702,
    viewBox: "0 0 30.946 27.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M765.411,246.1H742.7l9.914-8.869-2.667-2.981L734.464,248.1l15.482,13.851,2.667-2.981L742.7,250.1h22.711Z",
    transform: "translate(-734.464 -234.247)",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaBigGris);
export default __webpack_public_path__ + "static/media/flecha-big-gris.54d75930a3a948bbad3e5d03d0d48629.svg";
export { ForwardRef as ReactComponent };